'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoBug = function GoBug(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm15 6.1c-2 2.2-1.5 5.8-1.5 5.8s2.1 2.5 6.3 2.5c4.1 0 6.2-2.5 6.2-2.5s0.6-3.5-1.4-5.7c1.2-0.7 2-1.8 1.7-2.5-0.4-0.7-1.9-0.8-3.5-0.1-0.6 0.2-1.1 0.6-1.4 0.9-0.5-0.1-1-0.1-1.6-0.1-0.6 0-1.1 0-1.5 0.1-0.4-0.3-0.9-0.7-1.5-0.9-1.5-0.7-3.1-0.6-3.4 0.1-0.3 0.7 0.4 1.7 1.6 2.4z m15.7 16.2c-0.3-0.1-0.6-0.2-0.9-0.2 0-0.1 0-0.1 0-0.2 0-1.3-0.2-2.6-0.5-3.8 0.6 0.1 1.4-0.1 2.3-0.4 1.5-0.7 2.5-1.9 2.2-2.7-0.4-0.8-1.9-0.9-3.5-0.2-0.7 0.4-1.3 0.8-1.7 1.2-0.3-0.7-0.6-1.4-1-2-1.2 1-3.5 2.5-6.6 2.8v12.6s0 1.2-1.2 1.2-1.3-1.2-1.3-1.2v-12.6c-3.1-0.3-5.3-1.8-6.5-2.8-0.4 0.6-0.7 1.3-1 2-0.4-0.5-1-0.9-1.7-1.2-1.5-0.7-3.1-0.6-3.4 0.2-0.3 0.8 0.6 2 2.2 2.7 0.8 0.3 1.5 0.5 2.2 0.4-0.3 1.2-0.5 2.5-0.5 3.8 0 0.1 0 0.1 0 0.2-0.3 0.1-0.5 0.1-0.8 0.2-2.1 0.4-3.6 1.4-3.5 2.3 0.1 0.9 1.9 1.2 3.9 0.8 0.3-0.1 0.5-0.1 0.8-0.2 0.3 1.6 0.9 3.1 1.7 4.4-0.5 0.2-1 0.5-1.4 1-1.3 1.2-1.8 2.8-1.1 3.4s2.1 0.1 3.3-1.2c0.4-0.3 0.7-0.7 0.9-1.1 1.7 1.7 3.8 2.7 6.2 2.7 2.3 0 4.5-1 6.2-2.8 0.2 0.4 0.5 0.9 0.9 1.2 1.3 1.3 2.8 1.8 3.4 1.2s0.1-2.2-1.1-3.4c-0.5-0.5-1-0.9-1.5-1.1 0.8-1.3 1.3-2.7 1.7-4.3 0.3 0.1 0.6 0.1 0.9 0.2 2 0.4 3.7 0.1 3.9-0.8 0.1-0.9-1.5-1.9-3.5-2.3z' })
        )
    );
};

exports.default = GoBug;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/go/bug.js
// module id = 1853
// module chunks = 0